import { CellFormat } from './types';

export const formatValue = (value: string, format: CellFormat = 'text'): string => {
  if (!value) return '';

  switch (format) {
    case 'number':
      return formatNumber(value);
    case 'date':
      return formatDate(value);
    case 'money':
      return formatMoney(value);
    default:
      return value;
  }
};

export const parseValue = (value: string, format: CellFormat = 'text'): string => {
  if (!value) return '';
  value = value.replaceAll(',', '.');
  switch (format) {
    case 'number':
    case 'money':
      // Remove non-numeric characters except decimal separator
      return value.replace(/[^\d,-]/g, '').replace(',', '.');
    case 'date':
      // Convert DD/MM/YYYY to YYYY-MM-DD
      const [day, month, year] = value.split('/');
      return `${year}-${month}-${day}`;
    default:
      return value;
  }
};

const formatNumber = (value: string): string => {
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  
  return num.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatDate = (value: string): string => {
  try {
    const date = new Date(value);
    return date.toLocaleDateString('pt-BR');
  } catch {
    return value;
  }
};

const formatMoney = (value: string): string => {
  const num = parseFloat(value);
  if (isNaN(num)) return value;

  return num.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};